// Application constants

export const REGISTRATION_STATUS = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
};

export const FILE_UPLOAD = {
  MAX_SIZE_MB: 5,
  MAX_SIZE_BYTES: 5 * 1024 * 1024,
  ALLOWED_TYPES: ["image/jpeg", "image/png", "image/gif", "application/pdf"],
  ALLOWED_EXTENSIONS: [".jpg", ".jpeg", ".png", ".gif", ".pdf"],
};

export const VALIDATION_RULES = {
  EMAIL_REGEX:
    /^[a-zA-Z0-9]([a-zA-Z0-9._+-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9.-]*[a-zA-Z0-9])?\.[a-zA-Z]{2,}$/,
  MOBILE_REGEX: /^\+[1-9]\d{1,14}$/,
  PASSPORT_REGEX: /^[A-Z0-9]{6,9}$/,
  NATIONAL_ID_REGEX: /^[0-9A-Za-z]{4,16}$/,
  PASSWORD_MIN_LENGTH: 8,
};

export const ROUTES = {
  HOME: "/",
  REGISTER: "/register",
  ADMIN_LOGIN: "/admin/login",
  ADMIN_DASHBOARD: "/admin/dashboard",
  MODERATOR_DASHBOARD: "/admin/moderator",
  REFERRAL_REPORTS: "/admin/referral-reports",
  ITEM_MANAGEMENT: "/admin/item-management",
  LOCATION_MANAGEMENT: "/admin/location-management",
  CHANGE_PASSWORD: "/change-password",
  ORDERS: "/admin/orders",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
};

export const COLLECTIONS = {
  REGISTRATIONS: "registrations",
  USER_ACCOUNTS: "user_accounts",
  ADMIN_USERS: "admin_users",
  CATEGORIES: "categories",
  ITEMS: "items",
};

export const STORAGE_PATHS = {
  RECEIPTS: "receipts",
  ITEM_IMAGES: "item-images",
};

export const ERROR_MESSAGES = {
  NETWORK_ERROR: "Network error. Please check your connection and try again.",
  UNAUTHORIZED: "You are not authorized to perform this action.",
  FILE_TOO_LARGE: "File size must be less than 5MB.",
  INVALID_FILE_TYPE: "File must be an image (JPEG, PNG, GIF) or PDF.",
  EMAIL_EXISTS: "An account with this email already exists.",
  PHONE_EXISTS: "An account with this phone number already exists.",
  INVALID_CREDENTIALS: "Invalid email or password.",
  REQUIRED_FIELD: "This field is required.",
  INVALID_EMAIL: "Please enter a valid email address.",
  INVALID_MOBILE:
    "Please enter a valid international mobile number (e.g., +1234567890).",
  INVALID_PASSPORT:
    "Please enter a valid passport number (6-9 alphanumeric characters).",
  INVALID_NATIONAL_ID:
    "Please enter a valid ID Number (4-15 alphanumeric characters).",
  WEAK_PASSWORD:
    "Password must be at least 8 characters with uppercase, lowercase, numbers, and symbols.",
};

export const SUCCESS_MESSAGES = {
  REGISTRATION_SUBMITTED:
    "Registration submitted successfully! You will receive an email notification once reviewed.",
  LOGIN_SUCCESS: "Login successful!",
  PASSWORD_CHANGED: "Password changed successfully!",
  REGISTRATION_APPROVED: "Registration approved successfully!",
  REGISTRATION_REJECTED: "Registration rejected successfully!",
  EMAIL_SENT: "Email notification sent successfully!",
  CATEGORY_CREATED: "Category created successfully!",
  CATEGORY_UPDATED: "Category updated successfully!",
  CATEGORY_DELETED: "Category deleted successfully!",
  ITEM_CREATED: "Item created successfully!",
  ITEM_UPDATED: "Item updated successfully!",
  ITEM_DELETED: "Item deleted successfully!",
};

export const ITEM_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  OUT_OF_STOCK: "out_of_stock",
};

export const ITEM_UNITS = [
  "kg",
  "g",
  "lb",
  "oz",
  "piece",
  "pack",
  "bottle",
  "can",
  "box",
  "bag",
  "liter",
  "ml",
  "gallon",
  "dozen",
  "bundle",
  "tray",
  "jar",
  "tube",
];

export const GROCERY_CATEGORIES = [
  "Fruits & Vegetables",
  "Meat & Seafood",
  "Dairy & Eggs",
  "Bakery",
  "Pantry Staples",
  "Beverages",
  "Snacks & Candy",
  "Frozen Foods",
  "Health & Beauty",
  "Household Items",
  "Baby & Kids",
  "Pet Supplies",
  "Organic & Natural",
  "International Foods",
  "Deli & Prepared Foods",
];

export const COUNTRIES = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Democratic Republic of the Congo",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "East Timor",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Ivory Coast",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];
